<div class='modal-backdrop'>
  <div class='modal-dialog'>
    <div class='modal-content'>
      <div class='modal-header'>
        <h4 class='modal-title'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.RECOVER_EXTERNALLY_MODAL.TITLE' | translate }}</h4>
      </div>
      <form [formGroup]='recoverExternallyFormGroup' (ngSubmit)='onSubmitRecoverExternallyForm()' autocomplete='off' novalidate>
        <div class='form-horizontal form-label-left'>
          <div class='modal-body'>
            <div class='form-group'>

              <!-- TARGET STATUS -->
              <div class='form-group'>
                <label class='control-label col-sm-4 col-md-4 col-xs-4'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.RECOVER_EXTERNALLY_MODAL.TARGET_STATUS' | translate }}</label>
                <div class='col-sm-8 col-md-8 col-xs-8 status-value'>
                  <status-label type='TRANSACTIONS.STATUS' [status]='PaymentStatus.RECOVERED'></status-label>
                </div>
              </div>

              <!-- COMMENT -->
              <div class='form-group'>
                <label class='control-label col-sm-4 col-md-4 col-xs-4'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.RECOVER_EXTERNALLY_MODAL.COMMENT' | translate }}</label>
                <div class='col-sm-8 col-md-8 col-xs-8'>
                  <textarea class='form-control' rows='3' formControlName='comment' maxlength='255'></textarea>
                </div>
              </div>

            </div>
          </div>
          <div class='modal-footer'>
            <button type='submit' class='btn btn-success pull-right'>{{ 'ACTIONS.CONFIRM' | translate }}</button>
            <button type='button' class='btn btn-danger pull-right' (click)='cancel()'>{{ 'ACTIONS.CANCEL' | translate }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
